import type { Empresa } from "../types/empresa";

/* Empresa ativa no seletor global. Mantida fora dos componentes para que todos
   os modais que já usam este helper recebam a mesma regra sem duplicação. */
let codEmpresaAtiva = "";

function texto(valor: unknown): string {
  return String(valor ?? "").trim();
}

function normalizar(valor: unknown): string {
  return texto(valor)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

function extrairTagTexto(empresa: Empresa | null | undefined): string {
  const tagRaw = texto(empresa?.tag);
  const partes = tagRaw.split("|");
  return texto(partes[1] || partes[0]);
}

export function empresaEhMatriz(empresa: Empresa | null | undefined): boolean {
  if (!empresa) return false;
  return (
    normalizar((empresa as Record<string, unknown>).tipoEmpresa) === "matriz" ||
    normalizar(extrairTagTexto(empresa)) === "matriz"
  );
}

/** Sincroniza a empresa escolhida no topo com os valores iniciais dos modais. */
export function definirEmpresaAtivaPadrao(codEmpresa: unknown): void {
  const codigo = texto(codEmpresa);
  codEmpresaAtiva = codigo && codigo.toLowerCase() !== "todos" ? codigo : "";
}

/**
 * Para novos registros, prioriza sempre a empresa ativa da sessão. A matriz é
 * somente o fallback quando a sessão está em "Todas" ou a opção não foi carregada.
 */
export function obterEmpresaPadrao(empresas: Empresa[]): Empresa | undefined {
  return empresas.find((empresa) => texto(empresa.codEmpresa) === codEmpresaAtiva)
    ?? empresas.find((empresa) => empresaEhMatriz(empresa))
    ?? empresas[0];
}
